import $ from 'jquery';

// Various sanitizing functions for article page.
export default function () {
    // // Removes manually inserted ads with .sidebar wrapper element from legacy articles.
    // const numberOfPTags = $('.text-wrapper p').length;

    // // Recursively flow through p tags in the article backwards, look for p tags with content and above 120 chars in length, add the class 'final-dot'
    // function addFinalDot(nthPTag) {
    //     const $nthPTag = $('.text-wrapper p:nth-of-type(' + nthPTag + ')');
    //     const terminatingParagraphText = $nthPTag.text();

    //     if (terminatingParagraphText === '') {
    //         addFinalDot(nthPTag - 1);
    //         return;
    //     }

    //     $nthPTag.addClass('final-dot');
    // }

    // addFinalDot(numberOfPTags);

    // Remove manual inserted ad bb code from article
    $('.ad-bbcode').parent().parent('.sidebar').remove();
}
